import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { ChatEntity } from '../../domain/entities/ChatEntity'
import newMessageSound from '@/images/newMessageSound.wav'
import _ from 'lodash'
import { updateReadMessageCase } from '../../domain/usecases/updateReadMessageCase'
import { RoleType } from '@/features/role/domain/enums/RoleType'
import { sendNotification } from '@/utils/serviceWorker'
import type { UnavailableItemOrderEntity } from '@/features/order/domain/entities/UnavailableItemOrderEntity'

export const useNotificationStore = defineStore('notificationStore', () => {
  const messages = ref<ChatEntity[]>([])
  const openedChatUserId = ref<string | undefined>(undefined)
  const allMessages = ref<ChatEntity[]>([])
  const driverMessagesHistory = ref<ChatEntity[]>([])
  const unavailableItems = ref<UnavailableItemOrderEntity[]>([])

  function setMessages(newMessages: ChatEntity[]) {
    messages.value = newMessages.filter((message) => message.senderUserRoleType === RoleType.DRIVER)
  }
  function setAllMessages(newMessages: ChatEntity[]) {
    allMessages.value = newMessages
  }
  async function addMessage(newMessage: ChatEntity) {
    if (
      newMessage.senderUserId === openedChatUserId.value ||
      newMessage.receiverUserId === openedChatUserId.value
    ) {
      driverMessagesHistory.value.push(newMessage)
    }
    if (newMessage.senderUserRoleType !== RoleType.DRIVER) return

    const audio = new Audio(newMessageSound)
    audio.play()

    await sendNotification(
      `New message from ${newMessage.driverFullName || 'Driver'}`,
      newMessage.message && newMessage.message.length > 100
        ? newMessage.message.slice(0, 100) + '...'
        : newMessage.message || '',
      {
        icon: '/logo.png',
        badge: '/logo.png',
        url: `/chat?userId=${newMessage.senderUserRoleType === RoleType.DRIVER ? newMessage.senderUserId : newMessage.receiverUserId}`
      }
    )

    const messageIndex = messages.value.findIndex(
      (message) => message.driverId === newMessage.driverId
    )
    const allMessageIndex = allMessages.value.findIndex(
      (message) => message.driverId === newMessage.driverId
    )
    const count = _.cloneDeep(messages.value[messageIndex]?.count ?? 0)
    newMessage.count = count + 1

    if (messageIndex === -1) {
      messages.value.unshift(newMessage)
    } else {
      messages.value[messageIndex] = newMessage
    }
    if (allMessageIndex === -1) {
      allMessages.value.unshift(newMessage)
    } else {
      allMessages.value[allMessageIndex] = newMessage
    }
  }
  function seenMessage(userId: string) {
    const message = messages.value.find((message) => message.senderUserId === userId)
    if (message) {
      message.isRead = true
    }
    updateReadMessageCase(userId)
  }
  function seenAllMessages() {
    // messages.value.forEach((message) => {
    //   message.seen = true
    // })
  }
  function setUnavailableItems(items: UnavailableItemOrderEntity[]) {
    unavailableItems.value = items
  }
  function addUnavailableItem(item: UnavailableItemOrderEntity) {
    unavailableItems.value.push(item)
  }
  function addOpenedChatUserId(userId: string | undefined) {
    openedChatUserId.value = userId
  }
  function setDriverMessage(message?: ChatEntity[]) {
    driverMessagesHistory.value = message?.reverse() ?? []
  }
  function pushDriverMessages(messages: ChatEntity[]) {
    driverMessagesHistory.value.push(...messages)
  }
  function addDriverMessage(message: ChatEntity) {
    driverMessagesHistory.value.push(message)
  }
  return {
    messages,
    addMessage,
    seenMessage,
    seenAllMessages,
    setMessages,
    addOpenedChatUserId,
    openedChatUserId,
    driverMessagesHistory,
    setDriverMessage,
    addDriverMessage,
    pushDriverMessages,
    setAllMessages,
    allMessages,
    setUnavailableItems,
    unavailableItems,
    addUnavailableItem
  }
})
